import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environment/environment';
import {
  Relay,
  RelayDetails,
  CreateRelayDto,
  UpdateRelayDto,
} from '../models/relay.model';
import { OperatorPort } from '../models/port.model';

@Injectable({
  providedIn: 'root',
})
export class RelayService {
  private readonly apiUrl = `${environment.apiUrl}/relays`;

  constructor(private http: HttpClient) {}

  getRelays(facilityId?: string): Observable<Relay[]> {
    let params = new HttpParams();
    if (facilityId) {
      params = params.set('facilityId', facilityId);
    }
    return this.http.get<Relay[]>(this.apiUrl, { params });
  }

  getRelayById(id: string): Observable<Relay> {
    return this.http.get<Relay>(`${this.apiUrl}/${id}`);
  }

  getRelayDetails(id: string): Observable<RelayDetails> {
    return this.http.get<RelayDetails>(`${this.apiUrl}/${id}/details`);
  }

  getOperatorRelayPorts(relayId: string): Observable<OperatorPort[]> {
    return this.http.get<OperatorPort[]>(
      `${environment.apiUrl}/operator/relays/${relayId}/ports`,
    );
  }

  createRelay(dto: CreateRelayDto): Observable<Relay> {
    return this.http.post<Relay>(this.apiUrl, dto);
  }

  updateRelay(id: string, dto: UpdateRelayDto): Observable<Relay> {
    return this.http.put<Relay>(`${this.apiUrl}/${id}`, dto);
  }

  deleteRelay(id: string): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
}
